<div>
  <mat-label>It has been indicated you no longer require future pick-ups for this property</mat-label>
  <div (click)="reactiveSeason()">
    <i class="bts bt-exclamation-triangle bt-2x"></i>
    <mat-label>Re-Activate pick-ups for this property</mat-label>
  </div>
</div>